<template>
  <a
    class="wa-float"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener"
    :aria-label="$t('whatsapp.aria_label')"
  >
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M16.02 3C9.4 3 4 8.4 4 15.02c0 2.22.6 4.3 1.63 6.1L3 29l8.06-2.58a12.9 12.9 0 0 0 4.96.98h.01c6.62 0 12.02-5.4 12.02-12.02C28.05 8.4 22.65 3 16.02 3Zm0 21.98h-.01a10 10 0 0 1-4.53-1.08l-.33-.18-4.78 1.53 1.55-4.66-.21-.35a9.94 9.94 0 0 1-1.53-5.24c0-5.5 4.48-9.98 9.99-9.98 2.67 0 5.17 1.04 7.06 2.93a9.9 9.9 0 0 1 2.93 7.06c0 5.5-4.48 9.98-9.99 9.98Zm5.47-7.47c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.91-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.87 1.22 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z"
      />
    </svg>
  </a>
</template>

<script>
import { WHATSAPP_NUMBER } from '@/config.js'

export default {
  name: 'WhatsAppFloatButton',

  computed: {
    whatsappUrl() {
      const msg = encodeURIComponent(
        'Hola, vi su sitio y me interesa cotizar un proyecto.'
      )
      return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`
    }
  }
}
</script>

<style scoped>

.wa-float {
  position: fixed;
  right: 1.4rem;
  bottom: 1.4rem;
  z-index: 998;

  width: 56px;
  height: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: #25d366;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .28);

  transition: transform .18s ease, background .18s ease;
}

/* Anillo de pulso en un pseudo-elemento animando solo transform/opacity
   (compositor), en vez de box-shadow, que repintaba en cada frame. */
.wa-float::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(37, 211, 102, .45);
  z-index: -1;
  pointer-events: none;
  animation: waPulse 2.4s ease-out infinite;
}

.wa-float svg {
  width: 30px;
  height: 30px;
  fill: #fff;
}

.wa-float:hover,
.wa-float:focus-visible {
  background: #1ebe5b;
  transform: translateY(-2px);
}

.wa-float:focus-visible {
  outline: 2px solid #dcdfd2;
  outline-offset: 2px;
}

@keyframes waPulse {
  0%        { transform: scale(1); opacity: 1; }
  60%, 100% { transform: scale(1.36); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .wa-float::after {
    display: none;
  }
}

@media (max-width: 768px) {
  .wa-float {
    right: 1rem;
    bottom: 1rem;
    width: 50px;
    height: 50px;
  }

  .wa-float svg {
    width: 26px;
    height: 26px;
  }
}

</style>
